import Modal from '@/components/Common/Modal';
import { Close } from 'node_modules/@mui/icons-material/index';
import { getThemeColor } from 'src/utils/getThemeColor';

const WishlistItemDeletionAlert = ({showDeleteConfirmationModal, setShowDeleteConfirmationModal}) => {
  const themeColor = getThemeColor() || '#000000';

  return (
    <Modal
      visible={showDeleteConfirmationModal?.open}
      className="bottom-modal mw6-ns"
      animation={'slideUp'}
      height="auto"
      customStyles={{
        maxWidth: '450px',
      }}
      onClose={() => setShowDeleteConfirmationModal((prev) => ({
        ...prev,
        open: false,
      }))}
    >
      <div className="tw-flex tw-flex-col tw-gap-[18px]">
        <div className="tw-flex tw-justify-between"> 
          <span className="tw-text-[18px] tw-font-inter tw-font-bold">Remove Item</span>
          <div>
            <Close
          fontSize="small"
          style={{ cursor: 'pointer' }}
          onClick={() => setShowDeleteConfirmationModal((prev) => ({
              ...prev,
              open: false,
            }))}
        />
          </div>
        </div>
        <p className="tw-m-0 tw-text-sm tw-text-[#606060]">
          Are you sure you want to remove this item from your wishlist?
        </p>
        <div className="tw-flex tw-justify-end tw-gap-[16px]">
           <button
            onClick={() => showDeleteConfirmationModal?.confirmCallback()}
            className="tw-cursor-pointer tw-rounded-lg tw-border tw-border-solid tw-border-[#FF0000] tw-bg-transparent tw-p-[12px] tw-text-[#FF0000]"
          >
            Remove Item
          </button>
          <button
            onClick={() => setShowDeleteConfirmationModal((prev) => ({
              ...prev,
              open: false,
            }))}
            className="tw-cursor-pointer tw-rounded-lg tw-border tw-border-solid !tw-border-[#E3E3E3] tw-bg-transparent tw-p-[12px]"
            style={{
              color: themeColor,
            }}
          >
           Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default WishlistItemDeletionAlert;
